import system from './system.json';
import document from './document.json';
import type from './type.json';
import analysisLot from './analysisLot.json';
import actualPrices from './actualPrices.json';
import sysOptions from './sysOptions.json';
import licensing from './licensing.json';
import menuGroupNames from './menuGroupNames.json';
import kizOsu from './kizOsu.json';
import quickAccessBar from './quickAccessBar.json';
import userPanel from './userPanel.json';
import cashRegisterPanel from './cashRegisterPanel.json';
import cashSession from './cashSession.json';
import sidePanel from './sidePanel.json';
import login from './login.json';
import accounting from './accounting.json';
import directory from './directory';
import documents from './documents';
import reports from './reports.json';
import general from './general.json';
import documentsCommandsPanel from './documentsCommandsPanel.json';
import baseCreator from './baseCreator.json';
import errors from './errors.json';
import permissions from './permissions.json';
import importInvoice from './importInvoice.json';
import documentBase from './documentBase.json';
import modals from './modals.json';
import plugins from './plugins.json';
import alerts from './alerts.json'
import withdrawal from './withdrawal.json'

export default {
  system,
  document,
  type,
  analysisLot,
  actualPrices,
  sysOptions,
  licensing,
  menuGroupNames,
  kizOsu,
  quickAccessBar,
  userPanel,
  cashRegisterPanel,
  cashSession,
  sidePanel,
  login,
  accounting,
  directory,
  documents,
  reports,
  general,
  documentsCommandsPanel,
  baseCreator,
  errors,
  permissions,
  importInvoice,
  documentBase,
  modals,
  plugins,
  alerts,
  withdrawal
};
